import React from "react";
import { CTAButton } from "./CTAButton";
import { Reveal, STAGGER } from "./Reveal";
export function FinalCTA() {
  return <section aria-labelledby="final-cta" className="section-pad" data-id="element-183" data-mp="3udozur6inmq0">
      <div className="page-container grid gap-10 lg:grid-cols-12 lg:items-end lg:gap-8" data-id="element-184" data-mp="c7aew89tyci4">
        <Reveal className="lg:col-span-8" data-id="element-185" data-mp="85fd72nzlx3t">
          <h2 id="final-cta" className="h2-section" data-id="element-186" data-mp="83m5rl5jv8ur">
            Cada lead sin respuesta es{" "}
            <span className="text-gold" data-id="element-187" data-mp="m3dqs5uhhpi9">una venta para tu competencia.</span>
          </h2>
        </Reveal>
        <Reveal delay={STAGGER} className="lg:col-span-4 lg:flex lg:justify-end" data-id="element-188" data-mp="h5c5de9l5e3m">
          <CTAButton source="final" data-id="element-189" data-mp="vtghu0i1otdy" />
        </Reveal>
      </div>
    </section>;
}